import {
    useEffect,
    useState,
    useCallback,
} from 'react';

const useWindowScroll = () => {

    const [
        scroll,
        setScroll,
    ] = useState({
        x: null,
        y: null,
    });

    const disableWindowScroll = useCallback(() => {

        setScroll({
            x: window.pageXOffset,
            y: window.pageYOffset,
        });

    }, [setScroll]);

    const enableWindowScroll = useCallback(() => {

        setScroll({
            x: null,
            y: null,
        });

    }, [setScroll]);

    const scrollHandler = () => {

        if (scroll.x !== null && scroll.y !== null) {

            window.scrollTo(scroll.x, scroll.y);

        }

    };

    useEffect(() => {

        window.addEventListener('scroll', scrollHandler);

        return () => {

            window.removeEventListener('scroll', scrollHandler);

        };

    });

    return {
        disableWindowScroll,
        enableWindowScroll,
    };

};

export default useWindowScroll;
